import { ThirdPartyTransferStateEnum } from '@admin/schema';

export const getStateBadgeClass = (state: ThirdPartyTransferStateEnum) => {
  switch (state) {
    case ThirdPartyTransferStateEnum.Approved:
    case ThirdPartyTransferStateEnum.Outbounding:
    case ThirdPartyTransferStateEnum.Enroute:
    case ThirdPartyTransferStateEnum.Inbounding:
      return 'bg-info';
    case ThirdPartyTransferStateEnum.Canceled:
      return 'bg-danger';
    case ThirdPartyTransferStateEnum.Completed:
      return 'bg-success';
  }
};
